<template>
  <div class="page-header">
    <header class="lens-header-wrapper">
      <div class="header-wrapper">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <div class="lens-logo">
                <a href="" class="logo">
                  <img src="@/assets/title.png" alt="" />
                </a>
              </div>
            </div>
            <div class="col-xl-10 col-lg-9 col-md-8 col-sm-6 col-6">
              <div class="main-menu-container">
                <div class="main-menu" style="padding: 0px 70px">
                  <ul>
                    <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/home"
                        >首页</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/publicRental"
                        >公开招租</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/intentionRental"
                        >意向招租</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/info"
                        >资讯</router-link
                      >
                    </li>
                    <!-- <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/marketService"
                        >市场服务</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        "
                        active-class="active"
                        to="/investmentPromotionCenter"
                        >招商中心</router-link
                      >
                    </li> -->
                    <!-- <li>
                      <router-link style="
                          font-weight: bold;
                          font-size: 14px;
                          font-family: Arial;
                        " active-class="active" to="/platformIntroduction">平台介绍</router-link>
                    </li> -->
                  </ul>
                </div>
                <div class="right-content-wrapper">
                  <RightContent @userLogin="userLogin()"> </RightContent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <a-modal
      :width="750"
      :footer="null"
      :visible="loginVisible"
      :closable="false"
      @cancel="closeLoginMoudle"
      :maskClosable="true"
      :zIndex="999"
      destroyOnClose
    >
      <div class="login-container">
        <login
          @loginToRegister="loginToRegister()"
          @loginToForget="loginToForget()"
          @closeLogin="closeLogin()"
        ></login>
      </div>
    </a-modal>

    <a-modal
      :width="450"
      :footer="null"
      :visible="registerVisible"
      :closable="false"
      @cancel="closeRegisterMoudle"
      :maskClosable="true"
      :zIndex="999"
    >
      <div class="login-container">
        <Register @registerToLogin="registerToLogin()"></Register>
      </div>
    </a-modal>

    <a-modal
      :width="750"
      :footer="null"
      :visible="forgetVisible"
      :closable="false"
      @cancel="closeForgetMoudle"
      :maskClosable="true"
      :zIndex="999"
    >
      <div>
        <ForgetPassword
          @forgetToLogin="forgetToLogin()"
          @forgetToRegister="forgetToRegister()"
        ></ForgetPassword>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Login from "@/view/loginModule/Login.vue";
import Register from "@/view/loginModule/Register.vue";
import ForgetPassword from "@/view/loginModule/ForgetPassword.vue";
import RightContent from "./GlobalHeader/RightContent.vue";

export default {
  name: "PageHeader",
  components: {
    Login,
    Register,
    ForgetPassword,
    RightContent,
  },
  props: {
    prefixCls: {
      type: String,
      default: "ant-pro-global-header-index-action",
    },
  },
  data() {
    return {
      loginVisible: false,
      registerVisible: false,
      forgetVisible: false,
    };
  },
  methods: {
    userLogin() {
      this.loginVisible = true;
    },
    closeLogin() {
      this.loginVisible = false;
    },
    closeLoginMoudle() {
      this.loginVisible = false;
    },
    closeRegisterMoudle() {
      this.registerVisible = false;
    },
    closeForgetMoudle() {
      this.forgetVisible = false;
    },
    loginToRegister() {
      this.loginVisible = false;
      this.registerVisible = true;
    },
    loginToForget() {
      this.loginVisible = false;
      this.forgetVisible = true;
    },
    registerToLogin() {
      this.registerVisible = false;
      this.loginVisible = true;
    },
    forgetToLogin() {
      this.forgetVisible = false;
      this.loginVisible = true;
    },
    forgetToRegister() {
      this.forgetVisible = false;
      this.registerVisible = true;
    },
  },
};
</script>
<style scoped>
.login-container {
  padding: 10px;

  /* border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}
.login-title {
  font-size: 24px;
  margin-bottom: 10px;
  color: #000000;
}
.qr-description-top {
  color: #666;
  margin-bottom: 10px;
}
.qr-description-bottom {
  color: #666;
  margin-top: 20px;
}
.getCaptcha {
  display: block;
  width: 100%;
  height: 50px;
}
.right-content-wrapper {
  width: 250px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
}
</style>
